import template from './material-type-house.jade';
import materialType from '../../../enums/material-type-house';
import { isValidEnum } from '../../../utils';

export default angular
  .module('cian.addForm.commonMaterialTypeHouse', [])
  .directive('cianAfCommonMaterialTypeHouse', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller: [
      function () {
        this.materialTypeOptions = materialType;

        // удаляем невалидное значение, пришедшее из других категорий
        if (this.ad.building && !isValidEnum(this.materialTypeOptions, this.ad.building.materialType)) {
          this.ad.building.materialType = undefined;
        }
      },
    ],
    controllerAs: 'materialTypeHouse',
    template,
  })).name;
